<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增配置' : '编辑配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="排名区间：" prop="range">
          <el-input
            placeholder="从多少名"
            style="width: 80px"
            v-model="form.range[0]"
          ></el-input>
          -
          <el-input
            placeholder="到多少名"
            style="width: 80px"
            v-model="form.range[1]"
          ></el-input>
        </el-form-item>

        <el-form-item label="每日奖励：">
          <base-item-selector
            @updated="updatedItemSelectorOfDay"
            v-model="form.rewardsOfDay"
          ></base-item-selector>
        </el-form-item>
        <el-form-item label="赛季奖励：">
          <base-item-selector
            @updated="updatedItemSelectorOfSeason"
            v-model="form.rewardsOfSeason"
          ></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "../biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditHeroUpgradeLeaderboardDialog";
export default {
  data() {
    return {
      form: {
        rewardsOfDay: [],
        rewardsOfSeason: [],
        range: ["", ""],
      },
      isCreated: false,
      itemSelectorResultOfDay: null,
      itemSelectorResultOfSeason: null,
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;
  },
  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },

    save() {
      let fromRank = parseInt(this.form.range[0]);
      if (
        isNaN(fromRank) ||
        fromRank < 0 ||
        fromRank.toString() != this.form.range[0]
      ) {
        return { errMsg: "排名区间非法" };
      }
      let toRank = parseInt(this.form.range[1]);
      if (
        isNaN(toRank) ||
        toRank < 0 ||
        toRank.toString() != this.form.range[1]
      ) {
        return { errMsg: "排名区间非法" };
      }

      if (fromRank > toRank) {
        return { errMsg: "开始排名不能大于结束排名" };
      }

      if (this.itemSelectorResultOfDay.errMsg) {
        return { errMsg: this.itemSelectorResultOfDay.errMsg };
      }

      let rewardsOfDay = this.itemSelectorResultOfDay;
      if (rewardsOfDay.length == 0) {
        return { errMsg: "每日奖励最少配置一项" };
      }

      if (this.itemSelectorResultOfSeason.errMsg) {
        return { errMsg: this.itemSelectorResultOfSeason.errMsg };
      }

      let rewardsOfSeason = this.itemSelectorResultOfSeason;
      if (rewardsOfSeason.length == 0) {
        return { errMsg: "赛季奖励最少配置一项" };
      }

      return {
        range: [fromRank, toRank],
        rewardsOfDay: rewardsOfDay,
        rewardsOfSeason: rewardsOfSeason,
      };
    },

    async updatedItemSelectorOfDay(param) {
      this.itemSelectorResultOfDay = param;
    },
    async updatedItemSelectorOfSeason(param) {
      this.itemSelectorResultOfSeason = param;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

